import * as React from "react";

const Jet = () => (
  <svg viewBox="5 5 10 10" height="45" width="120">
    <path d="M6.19,7A0.89,0.89,0,1,1,5.3,6.12,0.89,0.89,0,0,1,6.19,7Zm-4.8.89A0.89,0.89,0,1,0,.5,7,0.89,0.89,0,0,0,1.39,7.9Zm16.5,2.7v0.6a1.15,1.15,0,1,1-2.3,0V9.29h2.3V7.78h-2.3V6.43H14v4.68a2.64,2.64,0,0,0,2.77,2.77,2.63,2.63,0,0,0,2.76-2.77V10.6H17.89Zm-4.67.62H8.48A1.6,1.6,0,0,0,10,12.46a1.46,1.46,0,0,0,1.33-.73H13.1a3,3,0,0,1-3,2.15,3.29,3.29,0,0,1,0-6.59C11.91,7.29,13.45,8.73,13.22,11.22ZM11.62,9.9A1.57,1.57,0,0,0,10,8.71,1.61,1.61,0,0,0,8.5,9.9h3.12ZM4.5,11.2a1.1,1.1,0,0,1-1.16,1.16A1.09,1.09,0,0,1,2.19,11.2V10.63H0.59v0.48a2.63,2.63,0,0,0,2.76,2.77,2.64,2.64,0,0,0,2.77-2.77V8.49H4.5V11.2Z" />
  </svg>
);

export default Jet;
